import { gql } from "@apollo/client";

export const GET_COMUNICADOS_ACTIVOS = gql`
    query GetComunicadosActivos {
        comunicadosActivos{
            titulo
            descripcion
            idTipoComunicado
        }
    }
`;

export const adaptComunicadosActivos = (comunicadosActivos) => {
    if (!comunicadosActivos) return [];
    return comunicadosActivos.map(c => ({
        ...c,
        mensaje: c.descripcion,
        tipo: c.idTipoComunicado === 1 ? "alerta" : c.idTipoComunicado === 2 ? "advertencia" : c.idTipoComunicado === 3 ? "comentario" : "mensaje",
    }));
}